/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для отдельного товаров в списке товаров на странице категории 2 уровня.
   */
  app.CategoryItemView = app.ItemView.extend({
    imageSize: 0,
    isModifiersOpened: false,
    additionalOptions: [
      'router',
      'collection',
      'currency',
      'mainWindow',
      'key',
      'isGalleryEnabled',
      'isNewBadgeColors'
    ],

    /** @inheritDoc */
    run: function () {
      var that = this;
      this.listTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-list-item');
      if (app.isMobile && this.model.get('type') === app.PRODUCT_SERVICE_TYPE) {
        this.listTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-list-item-service');
      }
      this.tileTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-tile-item');
      this.listModifiersTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-list-item-modifiers');
      this.cardsModifiersTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-cards-item-modifiers');
      this.xxlModifiersTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-xxl-item-modifiers');
      this.cardsTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-cards-item');
      this.xxlTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-xxl-item');
      this.tradeEquipmentTemplate = app.helpers.TemplateHelper.getTemplate('#catalog-trade-equipment-item');
      this.access = {
        canCreateWishItem: false,
        canDestroyWishItem: false
      };
      this.wtfId = this.model.get('id');
      this.favWtfId = this.model.get('id');
      // заполнение модификаторов по АПИ
      var modifiersData = _.get(this.model.get('small_modifiers'), 'values') || [];
      var modifierName = _.get(this.model.get('small_modifiers'), 'modifier_name') || '';
      this.modifiers = new app.Items(_.map(modifiersData, function (modifier) {
        return _.assign(_.omit(modifier, 'item'), modifier.item, {
          img: that.getModifierImage(modifier),
          modifier_name: modifierName,
        });
      }));
      this.modifiers.each(function (modifier) {
        var wishData = modifier.get('wish_item');
        if (wishData) {
          if (_.isString(wishData)) {
            try {
              wishData = JSON.parse(decodeURIComponent(wishData));
            } catch (e) {
              wishData = '';
            }
          }
          var wishItem = new app.WishItem(wishData);
          app.wish.add(wishItem, {silent: true});
        }
      });
      var currentModifier = this.modifiers.findWhere({id: this.model.get('id')});
      if (currentModifier) {
        currentModifier.set('selected', true);
      } else {
        this.modifiers.reset();
      }
      if (this.model.get('wish_item') && _.isObject(this.model.get('wish_item'))) {
        this.wishItem = new app.WishItem(this.model.get('wish_item'));
        app.wish.add(this.wishItem, {silent: true});
      }
      this.setAccessCreateOrDestroyWishItem();
      this.perishableTooltip();
      this.listenTo(this, 'removedFromWish', this.removeAndFetch);
      this.initItemDelivery();
      this.delegateEvents(_.extend(this.events, {
        'mouseenter .catalog__item-preview, .product__image': 'showImagePreview'
      }));
    },

    setAccessCreateOrDestroyWishItem: function() {
      if (this.model.get('wish_item') && _.isObject(this.model.get('wish_item'))) {
        this.access.canDestroyWishItem = true;
      } else {
        this.access.canCreateWishItem = true;
      }
    },

    initDom: function (replace) {
      this.favBtn = this.$('.fav-add');
      this.checkbox = this.$('input[type=checkbox]');
      if (this.modifiers instanceof app.Items && this.modifiers.length) {
        this.childViews.modifiersView = new app.ModifiersView({
          el: this.$el,
          collection: this.modifiers,
          categoryCollection: this.collection,
          currency: this.currency,
          model: this.model,
          isModifiersOpened: this.isModifiersOpened,
          user: this.user,
          mainWindow: this.mainWindow,
          isCatalog: true,
        });
        this.listenTo(this.childViews.modifiersView, 'modifier-click', this.handleChangeModifier);
        this.listenTo(this.childViews.modifiersView, 'toggle-more-modifier', function (opened) {
          this.isModifiersOpened = this.childViews.modifiersView.isModifiersOpened = opened;
        });
      }
      var item = new app.Item(this.model.toJSON()),
        cartItem = item.get('cart_item') ? item.get('cart_item') : null;
      if (!item) {
        throw new Error('Incorrect data modifiers in the API, modifier not found in basic model with article: ' + this.model.get('sid') + '.');
      }
      var qtyViewClass = app.CategoryItemQtyView;
      if (this.model.get('type') === app.PRODUCT_SERVICE_TYPE) {
        qtyViewClass = app.ServiceCategoryItemQtyView;
      }
      this.childViews.qtyView = new qtyViewClass({
        el: this.$('.btn-block'),
        item: item,
        model: new app.CartItem(cartItem, {item: item}),
        collection: this.collection,
        cart: this.cart,
        user: this.user,
        currency: this.currency,
        settlement: this.settlement,
      });
      this.listenTo(this.childViews.qtyView, 'update-on-sync', this.renderRetailFeeMarkupCost);
      if (this.access.canDestroyWishItem) {
        if (this.favBtn.hasClass('fav-big')) {
          this.favBtn.toggleClass('added with-icon_fav-not-active with-icon_fav-active');
        } else {
          this.favBtn.toggleClass('with-icon_favs-grey added with-icon_favs-red ctl-hidden');
        }
      }
      this.setTimer();
      // TODO Посмотреть почему не срабатывает стандартный remove у коллекции
      this.listenTo(app.wish, 'update', this.updateOnWish);
      if (!app.isMobile) {
        this.childViews.imagePreview = new app.ImagePreviewView({el: this.$('.hint-preview'), model: this.model});
      }
      this.addRating();
      if (replace) {
        this.updateOnWish();
      }
      if (this.isGalleryEnabled) {
        this.$('.catalog__item-link').on('click', this.showGallery.bind(this));
      }
    },

    removeAndFetch: function (qty) {
      if (!this.collection.canRemoveItems) {
        return;
      }
      this.remove();
      Backbone.trigger('removedFromWish', qty);
    },

    /** @inheritDoc */
    getItemId: function () {
      return this.model.id;
    },
    /**
     * Определяет класс карточки каталога товаров в зависимости от того транизтный ли товар и от сортировки по виду
     * @param viewType {string} вид отображения карточки товара
     * @param transitSettlements {array} содержит id городов, в которые возможно доставить транзитный товар
     * @param currentSettlementId {number} id города пользователя
     * @returns {string} класс карточки товара
     */
    getItemClass: function(viewType, transitSettlements, currentSettlementId) {
      var itemClass = app.isMobile ? 'catalog__item tile layout-inner' : 'catalog__item tile';
      if (viewType === 'cards' || viewType === 'xxl') {
        itemClass = 'product tile';
        if (app.isMobile) {
          itemClass = 'catalog__item mobile-card layout-inner';
        }
      }
      if (transitSettlements) {
        itemClass += ' transit-item';
        if (transitSettlements.indexOf(currentSettlementId) === -1) {
          itemClass += '--disabled';
        }
      }
      return itemClass;
    },
    /**
     * Рендеринг шаблона товара.
     * @returns {app.CategoryItemView}
     */
    render: function (element, replace) {
      if (!element) {
        var template,
          price = this.model.get('price'),
          priceOld = this.model.get('price_max'),
          inSet = this.model.get('in_set'),
          nestedUnitName = _.get(this.model, 'attributes.nestedUnit.name'),
          priceInSet,
          minSumForFreeDelivery = this.model.get('min_sum_for_free_delivery'),
          priceOldInSet,
          imageLink = '',
          hasCustomUnits = this.model.get('has_custom_qty_units'),
          modifiersWithoutChoice = this.model.get('item_group'),
          hasModifiersWithoutChoice = app.isNewViewModifiersEnabled
            && modifiersWithoutChoice
            && modifiersWithoutChoice.count_modifiers > 1,
          qtyIsWeight = this.model.get('is_weighted_goods');

        if (this.collection.viewtype === 'list') {
          template = this.listTemplate;
        } if (this.collection.viewtype === 'cards') {
          template = this.cardsTemplate;
          if (app.isMobile) {
            var link = this.model.get('img');
            imageLink = link.replace('140.jpg', '280.jpg');
          }
        } if (this.collection.viewtype === 'xxl') {
          template = this.xxlTemplate;
        } if (this.collection.viewtype === 'trade-equipment') {
          template = this.tradeEquipmentTemplate;
        } if (this.collection.viewtype === 'tiles') {
          template = this.tileTemplate;
        }

        if (hasModifiersWithoutChoice) {
          imageLink = modifiersWithoutChoice.thumbnails['140'];
          switch (this.collection.viewtype) {
            case 'list':
              template = this.listModifiersTemplate;
              break;
            case 'cards':
              if (app.isMobile) {
                imageLink = modifiersWithoutChoice.thumbnails['280'];
              }
              template = this.cardsModifiersTemplate;
              break;
            case 'xxl':
              imageLink = modifiersWithoutChoice.thumbnails['400'];
              template = this.xxlModifiersTemplate;
              break;
            default:
              template = this.listModifiersTemplate;
          }
          modifiersWithoutChoice = this.modifierPrices(modifiersWithoutChoice);
        }
        if (inSet > 0 && inSet !== 1) {
          priceInSet = app.helpers.NumberHelper.roundFloatPointNum(price / inSet);
          priceOldInSet = app.helpers.NumberHelper.roundFloatPointNum(priceOld / inSet);
        }

        if (hasCustomUnits) {
          price = priceInSet;
          priceOld = priceOldInSet;
        }
        if (qtyIsWeight) {
          price = app.helpers.NumberHelper.roundFloatPointNum(price * 10);
          priceOld = app.helpers.NumberHelper.roundFloatPointNum(priceOld * 10);
          hasCustomUnits = true;
          nestedUnitName = 'кг';
        }
        if (replace || this.collection.viewtype === 'xxl') {
          this.imageSize = this.$('.product__image .hint-img').outerHeight();
        }
        element = $(template({
          itemClass: this.getItemClass(
            this.collection.viewtype,
            this.model.get('transit_in_settlement'),
            this.settlement.get('settlement_id')
          ),
          price: app.helpers.NumberHelper.numberWithoutZeroFraction(price),
          priceOld: app.helpers.NumberHelper.numberWithoutZeroFraction(priceOld),
          priceInSet: app.helpers.NumberHelper.numberWithoutZeroFraction(priceInSet),
          model: this.model.toJSON(),
          modifiers: this.modifiers.toJSON(),
          hasModifiersWithoutChoice: hasModifiersWithoutChoice,
          modifiersWithoutChoice: modifiersWithoutChoice,
          imageSize: this.imageSize,
          hasCustomUnits: hasCustomUnits,
          nestedUnitName: app.helpers.HtmlHelper.formatUnit(nestedUnitName),
          isRemoteStoreWithTooltip: this.model.get('is_small_wholesale_available'),
          isModifiersOpened: this.isModifiersOpened,
          itemName: hasModifiersWithoutChoice ? modifiersWithoutChoice.group_name : this.getName(),
          minSumForFreeDelivery: app.helpers.NumberHelper.fractionNumber(minSumForFreeDelivery)[0],
          declination: app.helpers.DeclinationHelper.format,
          user: this.user.toJSON(),
          currency: this.currency,
          isCatalog: true,
          imageLink: imageLink,
          item3dModelFile: this.get3dModelFile(),
          key: this.key,
          isNewBadgeColors: this.isNewBadgeColors,
        }));
      }
      if (replace && this.$el && this.$el.length) {
        if (this.childViews.qtyView) {
          this.childViews.qtyView.remove();
        }
        this.$el.replaceWith(element);
      }
      if (!arguments.length || !arguments[0]) {
        this.setElement(element);
      }
      this.initDom(replace);
      this.perishableTooltip();
      this.renderRetailFeeMarkupCost(this.model);
      if (app.filterPageId) {
        this.addUrlParamsToLinks('.catalog__item-link, .product__inner > a.link', { 'filter_page_id': app.filterPageId });
      }
      // Если передан элемент извне, то не нужно рисовать цену, так как она уже нарисована статикой.
      this.childViews.qtyView.render({
        controls: [false, false],
        replace: replace,
      });
      // Если вид крупными карточками, то нужно ждать загрузку картинки и потом убирать у неё жестко заданные размеры.
      if (replace && this.imageSize) {
        this.addImageOnloadHandler();
      }
      return this;
    },

    /*
     * Добавляет обработчик на загрузку картинки.
     * После загрузки будут убраны жестко заданные размеры картинки.
     */
    addImageOnloadHandler: function () {
      var hintImg = this.$('.product__image .hint-img');
      if (hintImg.length > 0) {
        hintImg[0].onload = function () {
          hintImg.attr('style', '');
        };
      }
    },

    modifierPrices: function (modifiers) {
      modifiers.isRangePrice = modifiers.max_price !== modifiers.min_price;
      modifiers.min_price = app.helpers.NumberHelper.fractionNumber(modifiers.min_price);
      modifiers.max_price = app.helpers.NumberHelper.fractionNumber(modifiers.max_price);
      return modifiers;
    },

    getName: function () {
      return this.model.get('short_name') || this.model.get('name');
    },

    replace: function () {
      this.render(null, true);
    },

    /**
     * Показывает попап с превью-картинками
     * @param {Object} e
     */
    showImagePreview: function (e) {
      var withBigImage = this.$(e.currentTarget).hasClass('catalog__item-preview');
      if (this.childViews.imagePreview) {
        this.childViews.imagePreview.render(withBigImage);
      }
    },
    /**
     * Инициирует tooltip для товара
     */
    perishableTooltip: function () {
      var jsProp = this.$('.js-item-prop'),
      jsPropWhite = this.$('.js-item-prop-white');
      if (jsProp.length) {
        jsProp.tooltip({
          position: {
            my: 'center bottom-5',
            at: 'center top'
          },
          tooltipClass: 'b-tooltip b-tooltip_abs'
        });
      }
      if (jsPropWhite.length) {
        jsPropWhite.tooltip({
          position: {
            my: 'center bottom-9',
            at: 'center top'
          },
          tooltipClass: 'b-tooltip b-tooltip_abs b-tooltip-white'
        });
      }
    },

    /**
     * Обработка смены модификатора.
     * @param {app.Model} model
     */
    handleChangeModifier: function (model) {
      var replacedItemId = this.model.id;
      this.model = model;
      this.setAccessCreateOrDestroyWishItem();
      if (model.get('modifier').is_picture) {
        if (app.isMobile && this.$('.catalog-tabs-analog-colors').length) {
          this.positionModifiersContainer = this.$('.picture-modifier-container').scrollLeft();
        } else {
          this.positionModifiersContainer = this.$('.picture-modifier-container').scrollTop();
        }
      }
      this.replace();
      Backbone.trigger('item-replaced-by-modifier', replacedItemId, model);
      if (this.positionModifiersContainer) {
        if (app.isMobile) {
          this.$('.picture-modifier-container').scrollLeft(this.positionModifiersContainer);
        } else {
          // DOM не успевает обновляться после замены модели
          setTimeout(function () {
            this.$('.picture-modifier-container').scrollTop(this.positionModifiersContainer);
          }.bind(this), 0);
        }
      }
    },
    /**
     * Получаем картинку товара.
     * @param {Object} modifier
     * @returns {string}
     */
    getModifierImage: function (modifier) {
      var photo = _.get(modifier, 'item.photos[0]') || {};
      return photo.url_part + '140.jpg?=v' + photo.version;
    },

    /**
     * Показать галерею при нажатии на изображение.
     * @param {Event} e Событие.
     */
    showGallery: function (e) {
      if (this.$(e.target).is('img')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var maxResolution = this.model.get('photo_sizes');
        maxResolution = maxResolution[maxResolution.length - 1];
        Backbone.trigger('GalleryView:open', _.merge({
          imageUrls: this.model.get('photos').map(function (photo) {
            return photo.url_part + maxResolution + '.jpg';
          }),
          alt: this.model.get('name'),
        }, Boolean(this.model.get('video_file_url')) && {
          videoUrls: [this.model.get('video_file_url')],
        } ));
      }
    },
  });
})(jQuery);

}.call(window));